/**
 * InternalDocsAccess
 * Navigates the browser directly to the internal API docs.
 * The main BFF session cookie is sent automatically — no separate token
 * exchange is needed since the session was established at login.
 * Rendered as a ProtectedRoute so the user is guaranteed to be logged in.
 */

import React, { useEffect } from 'react'
import { API_BASE_URL } from '@services/api'

// In development the frontend (3000) and backend (5001) run on different ports.
// Redirect directly to the backend URL so Swagger UI fetches its assets and
// spec from the same origin as the cookie, avoiding proxy-forwarding edge cases.
const INTERNAL_DOCS_URL = API_BASE_URL.replace('/api', '/api/docs/internal/')

const InternalDocsAccess: React.FC = () => {
  useEffect(() => {
    // The session cookie is sent automatically on the browser navigation.
    // requireInternalDocsAccess on the backend checks the main session.
    window.location.href = INTERNAL_DOCS_URL
  }, [])

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="border-primary-600 mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-b-2"></div>
        <p className="text-sm text-gray-500 dark:text-gray-400">Opening Internal API Docs…</p>
      </div>
    </div>
  )
}

export default InternalDocsAccess
